import { createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex row wrap justify-c qa-svl-select-container" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Year")
const _hoisted_3 = ["value"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Division")
const _hoisted_6 = ["value"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "qa-svl-name" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" verses ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlaceholderText = _resolveComponent("PlaceholderText")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["qa-select-verse-list", { faded: !_ctx.vlYears.length }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_Select, {
          disabled: !_ctx.vlYears.length,
          modelValue: _ctx.selectedYear,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedYear) = $event)),
          class: "col-xs-full"
        }, {
          label: _withCtx(() => [
            _hoisted_2
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vlYears, (year) => {
              return (_openBlock(), _createElementBlock("option", {
                key: year,
                value: year
              }, _toDisplayString(year), 9, _hoisted_3))
            }), 128)),
            (!_ctx.vlYears.length)
              ? (_openBlock(), _createElementBlock("option", _hoisted_4, [
                  _createVNode(_component_PlaceholderText, { length: 3 })
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["disabled", "modelValue"]),
        _createVNode(_component_Select, {
          disabled: !_ctx.vlDivisions.length,
          modelValue: _ctx.selectedDivision,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedDivision) = $event)),
          class: "col-xs-full"
        }, {
          label: _withCtx(() => [
            _hoisted_5
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vlDivisions, (division) => {
              return (_openBlock(), _createElementBlock("option", {
                key: division,
                value: division
              }, _toDisplayString(division), 9, _hoisted_6))
            }), 128)),
            (!_ctx.vlDivisions.length)
              ? (_openBlock(), _createElementBlock("option", _hoisted_7, [
                  _createVNode(_component_PlaceholderText, { length: 4 })
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["disabled", "modelValue"])
      ]),
      _createElementVNode("p", _hoisted_8, [
        _createTextVNode(_toDisplayString(_ctx.selectedVl?.name), 1),
        (!_ctx.selectedVl)
          ? (_openBlock(), _createBlock(_component_PlaceholderText, {
              key: 0,
              length: 8
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("p", null, [
        _createTextVNode(_toDisplayString(_ctx.selectedVl?.count) + " ", 1),
        (!_ctx.selectedVl)
          ? (_openBlock(), _createBlock(_component_PlaceholderText, {
              key: 0,
              length: 2
            }))
          : _createCommentVNode("", true),
        _hoisted_9
      ]),
      _createVNode(_component_Button, {
        class: "qa-svl-select-button",
        disabled: !_ctx.selectedVl,
        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('select', _ctx.selectedVl)), ["prevent"]))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Icon, { name: "chevron_right" })
        ]),
        _: 1
      }, 8, ["disabled"])
    ], 2),
    (!_ctx.vlYears.length)
      ? (_openBlock(), _createBlock(_component_Spinner, {
          key: 0,
          class: "qa-svl-spinner",
          delay: 0
        }))
      : _createCommentVNode("", true)
  ], 64))
}